import { createSelector } from '@reduxjs/toolkit'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const getFlashExtendDatesEnabled = createSelector(
  (state: App.State) => state.optimizely.optimizelyFeatureFlags,
  (optimizelyFeatureFlags): boolean => {
    return !!optimizelyFeatureFlags[OptimizelyFeatureFlags.flashExtendDatesEnabled] // && offer?.type === 'hotel'
  },
)
